export const downloadAsFile = (contents: string, filename: string, mimeType: string = 'text/plain'): void => {
  const blob = new Blob([contents], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoke — Safari/older WebKit can cancel the download if the blob
  // URL is revoked before the navigation handler reads it.
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
